import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import fr from '../locales/fr/translation.json';
import en from '../locales/en/translation.json';
import ar from '../locales/ar/translation.json';

const LANGUAGE_STORAGE_KEY = 'bsohtak_backoffice_language';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  ar: { translation: ar },
};

const getBrowserLanguage = (): string => {
  try {
    const browserLang = navigator.language.split('-')[0];
    // Si la langue du navigateur est supportée, on l'utilise, sinon français par défaut
    if (['fr', 'en', 'ar'].includes(browserLang)) {
      return browserLang;
    }
  } catch (error) {
    console.log('Could not get browser language, using default');
  }
  return 'fr';
};

const initI18n = () => {
  let savedLanguage = 'fr';

  // Sur web, utiliser localStorage si disponible
  if (typeof window !== 'undefined' && window.localStorage) {
    savedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY) || getBrowserLanguage();
  } else {
    savedLanguage = getBrowserLanguage();
  }

  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: savedLanguage,
      fallbackLng: 'fr',
      interpolation: {
        escapeValue: false,
      },
    });
};

export const changeLanguage = (language: string) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  }
  i18n.changeLanguage(language);
};

export const getCurrentLanguage = () => i18n.language;

// Initialiser i18n
if (typeof window !== 'undefined') {
  initI18n();
}

export default i18n;
